export const QueryParameter = "char";
